<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'base-collapse',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  setup() {
    const isOpen = ref(false)
    const containerRef = ref<HTMLElement | null>(null)
    const contentRef = ref<HTMLElement | null>(null)

    function toggle() {
      isOpen.value = !isOpen.value
    }

    function onEnter(el: Element) {
      if (el instanceof HTMLElement) {
        el.style.height = '0'

        // Force repaint
        el.offsetHeight

        el.style.height = `${el.scrollHeight}px`
      }
    }

    function onAfterEnter(el: Element) {
      if (el instanceof HTMLElement) {
        el.style.height = 'auto'
      }
    }

    function onLeave(el: Element) {
      if (el instanceof HTMLElement) {
        el.style.height = `${el.scrollHeight}px`

        // Force repaint

        el.offsetHeight

        el.style.height = '0'
      }
    }

    return {
      isOpen,
      containerRef,
      contentRef,
      toggle,
      onEnter,
      onAfterEnter,
      onLeave,
    }
  },
})
</script>

<template>
  <div class="border rounded-md overflow-hidden bg-white">
    <button
      type="button"
      class="w-full px-4 py-2 flex items-center justify-between text-left bg-gray-50 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
      @click="toggle"
    >
      <span class="font-medium text-gray-900">
        <slot name="title">
          {{ title }}
        </slot>
      </span>
      <span
        class="ml-6 flex items-center transition-transform duration-300"
        :class="{ 'transform rotate-180': isOpen }"
      >
        <svg
          class="w-5 h-5 text-gray-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </button>
    <transition
      name="collapse"
      @enter="onEnter"
      @after-enter="onAfterEnter"
      @leave="onLeave"
    >
      <div
        v-if="isOpen"
        ref="contentRef"
        class="overflow-hidden transition-all duration-300 ease-in-out"
      >
        <div class="px-4 py-4 border-t border-gray-200">
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
/* These styles are applied when transition happens not handled by class */
.collapse-enter-active,
.collapse-leave-active {
  overflow: hidden;
  transition: height 0.3s ease-in-out;
}

.collapse-enter-from,
.collapse-leave-to {
  height: 0 !important;
}
</style>
